import React from 'react';
import cls from 'classnames';
import styles from './Loader.module.scss';

function Loader({straightCorners = false, stickyCircle = false, ...other}) {
  return (
    <div className={cls(styles.loader, {[styles.straightCorners]: straightCorners, [styles.stickyCircle]: stickyCircle})} {...other}/>
  );
}

export default Loader;
